import { o as o_util } from "../chunks/common-namespaces-client-DhfOpdyM.mjs";
const attributeParser = o_util.attributeParser ?? {};
const parseParameters = attributeParser.parseParameters;
const parseAttributeName = attributeParser.parseAttributeName;
const mergeParameterValues = attributeParser.mergeParameterValues;
export {
  attributeParser,
  mergeParameterValues,
  parseAttributeName,
  parseParameters
};
/*                                                */
